import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "paragraph-SG78w",
  "use": "paragraph-SG78w-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"paragraph-SG78w\"><path fill-rule=\"evenodd\" d=\"M6 0h8v15h-2V2H8v13H6V0zM4.5 0H6v9H4.5a4.5 4.5 0 0 1 0-9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol